// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "qroo-app." + "363827d5e739690f7ea6" + ".css";
};